/**
 * Created by fers on 27.04.16.
 */
import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import TableDetail from '../../../fw/TableDetail.react.js';
import {ParentTemplate} from '../../box-utils/ParentTemplate.react.js';
import {relayWrap} from '../../box-utils/ParentBox.react.js';

import {viewWithDataGetPrimaryData} from '../../box-utils/PrimaryData';
import Error from './Error.react.js';
import {sendError} from '../../../app/errorDisplayer';
import BoxDecorator from '../../box-utils/BoxDecorator.react';

import {renderPreviewDefault} from './JSONTable';
import EmptyContent from './EmptyContent.react';
import {getAutoIcon} from './HTMLTemplate.react';
import PanelColumns from './PanelColumns.react';
import {JSONTableNew} from './JSONTableNew.react';
import {safeJSONparse} from "../../../../common/util/safeJSONparse";

class JSONDetail extends ParentTemplate {

    static handlerName = "json-detail";

    static propTypes = {
        viewWithData: PropTypes.object.isRequired,
    };

    getIcon() {
        let icon = getAutoIcon(this.props.viewWithData);

        if (icon) {
            return icon;
        }

        return "fa-list";
    }

	getServiceName() {
		let {entityDef} = this.props.viewWithData;

		if (entityDef && entityDef.name) {
			return entityDef.name;
		}
	}

	// eslint-disable-next-line max-params
    renderPreview(content, column, item, url, columnMapping) {
        return renderPreviewDefault(content, column, item, url, columnMapping);
    }

	gotoConfigureTable() {
		if (this.props.isPreview) {
			return;
		}

		// TODO open screen settings in panel. Something else somewhere else?
	}

    render() {
        let {view} = this.props.viewWithData;
        let {entityViewDef} = view;
        let data = viewWithDataGetPrimaryData(this.props.viewWithData);

        if (!data) {
            data = [];
        }

        let templateArray = [];

        if (entityViewDef) {
            try {
                templateArray = safeJSONparse(entityViewDef['template']);
            } catch (e) {
                sendError(e);
            }
        } else if (this.props.viewWithData.entityDef && this.props.viewWithData.entityDef.allFieldDefs) {
            templateArray = this.props.viewWithData.entityDef.allFieldDefs.edges.map(({node}) => node['realId']);
        }


        /* we want to render example data */
        if (this.props.isPreview) {
            if (this.props.viewWithData.entityDef && this.props.viewWithData.entityDef.allFieldDefs) {
                let exampleRow = {};

                for (let field of this.props.viewWithData.entityDef.allFieldDefs.edges) {
                    if (field.node.exampleData) {
                        exampleRow[field.node.realId] = field.node.exampleData;
                    }
                }

                data = [
                    {
                        key: '1',
                        ...exampleRow
                    }
                ];
            } else {
                data = [{key: '1'}];
            }
        }

        let templateColumns = {};

        for (let column of templateArray) {
            /**
             * backward compatiblity (it used to be array only)
             */
            if (typeof column === "string") {
                column = {
                    id: column
                };
            }

            templateColumns[column.id] = {};
        }

		if (!this.props.isPreview && JSONDetail.isEmpty(this.props.viewWithData)) {
			return (
				<BoxDecorator icon={this.getIcon()} isPreview={this.props.isPreview} title={this.getServiceName()}>
					<EmptyContent icon={this.getIcon()} isPreview={this.props.isPreview} title={this.getServiceName()} />
				</BoxDecorator>
			);
		}

		let columnCount = JSONTableNew.getLimit(this.props.viewWithData);

		templateColumns = JSONTableNew.getColumnsFromViewDefStatic(this.props);

        try {
            return (
                <BoxDecorator icon={this.getIcon()} isPreview={this.props.isPreview} title={this.getServiceName()}>
					<PanelColumns small>
						{data.map((row, idx) => {
							return (
								<TableDetail
									columns={templateColumns}
									data={row}
									fixedTitleWidth
									key={idx}
									metadata={this.getMetaData()}
									render={this.props.isPreview ? this.renderPreview : null}
								/>
							);
						})}
					</PanelColumns>
					{this.props.isPreview ? null : <small>
						<div className="detailView configureJsonTable flex-row" key="-1">
							<span className="excerptMessage"><FormattedMessage defaultMessage="Displayed first {count} records" id="jsonTable" values={{count: columnCount}} /></span>
							<span className="flex"></span>
							<a onClick={this.gotoConfigureTable.bind(this)}><i className="fa fa-pencil"></i> <FormattedMessage defaultMessage="Configure view" id="jsonDetail.configureView" /></a>
						</div>
					</small>}
                </BoxDecorator>
            );
        } catch (e) {
            sendError(e);
            return (<Error error={e} />);
        }
    }
}

export default relayWrap(JSONDetail);
